// This tab is signing a user in or out, and loads a page once that lands. The auth listener (syncSession) reloads a tab
// for a user change another tab made (Supabase broadcasts it with no origin), so the tab that makes one says so first.
let signingInOrOut = false;

// Runs this tab's sign-in or sign-out (a Supabase auth call) as this tab's own: set until the page it then loads, cleared
// if the call fails.
export async function signInOrOutHere<T extends { error: unknown }>(action: () => Promise<T>): Promise<T> {
  signingInOrOut = true;
  try {
    const result = await action();
    if (result.error) signingInOrOut = false;
    return result;
  } catch (e) {
    signingInOrOut = false;
    throw e;
  }
}

export const isSigningInOrOut = (): boolean => signingInOrOut;
